import { render, staticRenderFns } from "./reg-step1.vue?vue&type=template&id=7d93a685&scoped=true"
import script from "./reg-step1.vue?vue&type=script&lang=js"
export * from "./reg-step1.vue?vue&type=script&lang=js"
import style0 from "./reg-step1.vue?vue&type=style&index=0&id=7d93a685&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d93a685",
  null
  
)

export default component.exports